import { ArrowRight, ChevronDown, Quote, Flower2 } from "lucide-react";
import { HERO_QUOTE } from "../mock";

export default function HeroBottom() {
  return (
    <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-12 gap-8 items-end relative">
      <Flower2
        className="pointer-events-none absolute left-[36%] bottom-2 text-[#FCA5A5] fill-[#FCA5A5] bounce-soft hidden md:block"
        size={22}
      />
      <span className="pointer-events-none absolute right-[30%] bottom-6 w-3 h-3 bg-[#FFE14D] rotate-12 hidden md:block" />

      <div className="md:col-span-5 fade-up-delay-2" data-testid="hero-quote">
        <Quote size={26} className="fill-black text-black" />
        <p className="mt-3 text-[15px] text-neutral-700 leading-relaxed max-w-[420px]">
          {HERO_QUOTE}
        </p>
        <p className="handwritten text-3xl mt-2 relative inline-block">
          <span className="relative z-10">Prince Khedkar</span>
          <span className="absolute left-0 right-0 bottom-1 h-2.5 bg-[#FFE14D] -z-0" />
        </p>
        <div className="flex flex-wrap gap-3 mt-5">
          <a
            href="#work"
            className="h-11 px-5 rounded-full border-2 border-black text-sm font-semibold hover:bg-black hover:text-white transition-colors flex items-center"
            data-testid="hero-view-work-btn"
          >
            View Work
          </a>
          <a
            href="#contact"
            className="h-11 px-5 rounded-full bg-black text-white text-sm font-semibold hover:bg-neutral-800 transition-colors flex items-center"
            data-testid="hero-start-project-btn"
          >
            Start a Project
          </a>
        </div>
      </div>

      <div className="hidden md:col-span-3 md:flex justify-center fade-up-delay-3">
        <a
          href="#about"
          className="h-11 px-6 inline-flex items-center gap-2 rounded-full border border-black/15 text-xs tracking-[0.2em] uppercase font-semibold hover:bg-black hover:text-white transition-colors"
          data-testid="hero-scroll-down"
        >
          Scroll down <ChevronDown size={14} />
        </a>
      </div>

      <div className="md:col-span-4 flex items-center justify-between md:justify-end gap-5 fade-up-delay-3">
        <div className="flex items-start gap-3">
          <span className="display text-[44px] md:text-[52px] leading-none text-neutral-300">01</span>
          <div>
            <p className="text-[11px] tracking-[0.15em] uppercase text-neutral-500 mb-1">
              Free · 20 min · Google Meet
            </p>
            <p className="display text-[17px] md:text-[19px] leading-tight">
              Grab a free discovery slot,
              <br className="hidden sm:block" /> no email back-and-forth
            </p>
          </div>
        </div>
        <button
          data-book
          aria-label="Book a discovery call"
          className="w-14 h-14 shrink-0 rounded-full bg-black text-white flex items-center justify-center hover:bg-[#FFE14D] hover:text-black transition-colors"
          data-testid="hero-discovery-cta"
        >
          <ArrowRight size={20} />
        </button>
      </div>
    </div>
  );
}
